import { ApplicationRef, ComponentFactoryResolver, ComponentRef, Directive, ElementRef, HostListener, Injector, Input, OnDestroy } from '@angular/core';
import { ViolationTooltipData } from '../model/violation-tooltip-data';
import { ViolationTooltipComponent } from '../component/violation-tooltip/violation-tooltip.component';

@Directive({
  selector: '[appViolationTooltip]'
})
export class ViolationTooltipDirective implements OnDestroy {

  @Input('appViolationTooltip') tooltipData: ViolationTooltipData;

  private tooltipRef?: ComponentRef<ViolationTooltipComponent>;
  private showTimeoutId?: ReturnType<typeof setTimeout>;
  private readonly delay: number = 700;

  constructor(
    private host: ElementRef,
    private cfr: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector
  ) { }

  @HostListener('mouseenter')
  onMouseEnter(): void {
    this.showTimeoutId = setTimeout(() => {
      this.showTooltip();
    }, this.delay);
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    if (this.showTimeoutId) {
      clearTimeout(this.showTimeoutId);
      this.showTimeoutId = undefined;
    }

    if (this.tooltipRef) {
      this.appRef.detachView(this.tooltipRef.hostView);
      this.tooltipRef.destroy();
      this.tooltipRef = undefined;
    }
  }

  private showTooltip(): void {
    if (this.tooltipData) {
      const factory = this.cfr.resolveComponentFactory(ViolationTooltipComponent);
      this.tooltipRef = factory.create(this.injector);

      const tooltipEl = this.tooltipRef.location.nativeElement;

      this.tooltipRef.instance.data = this.tooltipData;

      this.tooltipRef.changeDetectorRef.detectChanges();

      this.appRef.attachView(this.tooltipRef.hostView);
      document.body.appendChild(tooltipEl);
      this.setPosition();
    }
  }

  private setPosition(): void {
    if (!this.tooltipRef) return;
    const hostEl = this.host.nativeElement as HTMLElement;
    const tooltipEl = this.tooltipRef.location.nativeElement as HTMLElement;

    const hostRect = hostEl.getBoundingClientRect();
    const tooltipRect = tooltipEl.getBoundingClientRect();

    const spacing = 8;
    const viewportWidth = window.innerWidth;

    let top = hostRect.top - tooltipRect.height - spacing;

    if (top < 0) {
      top = hostRect.bottom + spacing;
    }

    let left = hostRect.left + (hostRect.width - tooltipRect.width) / 2;

    if (left < spacing) {
      left = spacing;
    }

    if (left + tooltipRect.width > viewportWidth) {
      left = viewportWidth - tooltipRect.width - spacing;
    }

    tooltipEl.style.top = `${top}px`;
    tooltipEl.style.left = `${left}px`;
    tooltipEl.style.zIndex = '1000';
  }

  ngOnDestroy(): void {
    if (this.tooltipRef) {
      this.appRef.detachView(this.tooltipRef.hostView);
      this.tooltipRef.destroy();
    }

    if (this.showTimeoutId) {
      clearTimeout(this.showTimeoutId);
      this.showTimeoutId = undefined;
    }
  }
}
